import { Link, useNavigate } from 'react-router-dom'
import { useAppDispatch, useAppSelector } from '@/hooks/redux'
import { logout } from '@/store/slices/authSlice'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSignOut, faTerminal, faCog } from '@fortawesome/free-solid-svg-icons'
import { useTranslation } from 'react-i18next'

/**
 * Header component with navigation and user menu
 * Dark mode geek aesthetic - Desktop only
 */
export default function Header() {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const { user } = useAppSelector((state) => state.auth)
  const { t } = useTranslation()

  const handleLogout = async () => {
    try {
      await dispatch(logout()).unwrap()
    } catch (error) {
      console.error('Logout error:', error)
    } finally {
      navigate('/login')
    }
  }

  return (
    <header className="bg-slate-900 border-b border-slate-800/50 sticky top-0 z-40">
      <div className="px-8 py-5">
        <div className="flex flex-row items-center justify-between">
          <div className="flex items-center gap-8">
            {/* Logo/Brand */}
            <Link to="/" className="flex items-center gap-4 group">
              <div className="p-2 bg-linear-to-br from-cyan-600 to-purple-600 rounded-lg group-hover:shadow-lg group-hover:shadow-cyan-500/50 transition">
                <FontAwesomeIcon icon={faTerminal} className="text-white text-lg" />
              </div>
              <div>
                <h1 className="text-xl font-black bg-linear-to-r from-cyan-400 to-purple-400 bg-clip-text text-transparent">
                  KaraoNow
                </h1>
                <p className="text-xs text-slate-400 font-mono tracking-wider">SuperAdmin</p>
              </div>
            </Link>

            {/* Navigation */}
            <nav className="flex flex-row items-center gap-6">
              <Link
                to="/"
                className="text-slate-400 hover:text-cyan-400 transition font-mono text-sm"
              >
                {'< '}Dashboard{' />'}
              </Link>
              <Link
                to="/organizers"
                className="text-slate-400 hover:text-purple-400 transition font-mono text-sm"
              >
                {'< '}Organisateurs{' />'}
              </Link>
              <Link
                to="/events"
                className="text-slate-400 hover:text-amber-400 transition font-mono text-sm"
              >
                {'< '}Événements{' />'}
              </Link>
              <Link
                to="/venues"
                className="text-slate-400 hover:text-blue-400 transition font-mono text-sm"
              >
                {'< '}Lieux{' />'}
              </Link>
              <Link
                to="/singers"
                className="text-slate-400 hover:text-pink-400 transition font-mono text-sm"
              >
                {'< '}Chanteurs{' />'}
              </Link>
              <Link
                to="/revenue"
                className="text-slate-400 hover:text-green-400 transition font-mono text-sm"
              >
                {'< '}Revenus{' />'}
              </Link>
            </nav>
            </div>
            <div className="flex flex-row items-center justify-between">
            {/* User menu */}
            <div className="flex items-center gap-4">
              <div className="text-right">
                {/* <p className="text-xs font-mono text-slate-500 uppercase tracking-wider">{t('common.email')}</p> */}
                <p className="text-sm font-semibold text-slate-200">{user?.profile?.firstName}</p>
              </div>
              <Link
                to="/settings"
                className="flex items-center gap-2 px-3 py-2 bg-slate-800 hover:bg-slate-700 text-slate-300 hover:text-cyan-400 rounded-lg transition font-mono text-sm border border-slate-700/50 hover:border-slate-600"
                title={t('superadmin.settings')}
              >
                <FontAwesomeIcon icon={faCog} />
              </Link>
              <button
                onClick={handleLogout}
                className="flex items-center gap-2 px-4 py-2 bg-slate-800 hover:bg-red-900/50 text-red-400 rounded-lg transition font-mono text-sm border border-slate-700/50 hover:border-red-500/50"
                title={t('common.logout')}
              >
                <FontAwesomeIcon icon={faSignOut} />
                {/* {t('common.logout')} */}
              </button>
            </div>
          </div>
        </div>
      </div>
    </header>
  )
}

